module.exports = cfp.vendors.React;